import Home from '~/main_app/pages/Home'

export default Home
